"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _externalmanagement = require("@/api/externalmanagement.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _org = require("@/api/org");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultExternalManagement = {
  medical_name: '',
  medical_address: '',
  contact_name: '',
  contact_phone: '',
  source_ip: '',
  webhook_url: '',
  access_key_id: '',
  access_key_secret: '',
  authorization_time: '',
  sales_channel: '',
  recommender: '',
  dept_no: ''
};
var phoneValidator = function phoneValidator(rule, value, callBack) {
  var reg = /^[1][0-9]{10}$/;
  if (value) {
    if (!reg.test(value)) {
      callBack('请输入正确的联络人手机号');
    } else {
      callBack();
    }
  } else {
    callBack();
  }
};
var _default = exports.default = {
  data: function data() {
    return {
      externalmanagement: defaultExternalManagement,
      tableData: {},
      listLoading: true,
      listQuery: {
        page: 1,
        page_size: 10
      },
      dialogVisible: false,
      dialogType: 'new',
      rule1: {
        medical_name: [{
          required: true,
          message: '请输入医院名称',
          trigger: 'blur'
        }],
        contact_name: [{
          required: true,
          message: '请输入联络人名称',
          trigger: 'blur'
        }, {
          max: 20,
          message: '输入长度不能超过20位'
        }],
        contact_phone: [{
          required: true,
          message: '请输入联络人手机号',
          trigger: 'blur'
        }, {
          validator: phoneValidator
        }, {
          max: 11,
          message: '输入长度不能超过11位'
        }],
        medical_address: [{
          required: true,
          message: '请输入医院地址',
          trigger: 'blur'
        }, {
          max: 100,
          message: '输入长度不能超过100位'
        }],
        source_ip: [{
          required: true,
          message: '请输入请求主机来源ip',
          trigger: 'blur'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        authorization_time: [{
          required: true,
          message: '请输入授权有限时间',
          trigger: 'blur'
        }],
        webhook_url: [{
          required: true,
          message: '请输入Webhook(客戶端接口地址)',
          trigger: 'blur'
        }, {
          max: 100,
          message: '输入长度不能超过100位'
        }],
        sales_channel: [{
          required: true,
          message: '请输入销售通路',
          trigger: 'blur'
        }],
        recommender: [{
          required: true,
          message: '请输入所有医生推荐人编码',
          trigger: 'blur'
        }],
        dept_no: [{
          required: true,
          message: '请输入所有医生所属部门编码',
          trigger: 'blur'
        }]
      },
      orgList: [],
      disabled: false
    };
  },
  created: function created() {
    this.getList();
    this.getOrgList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _externalmanagement.getExternalManagementList)(this.listQuery).then(function (res) {
        _this.listQuery.page_size = res.data.count;
        (0, _externalmanagement.getExternalManagementList)(_this.listQuery).then(function (response) {
          if (response.data) {
            _this.tableData = response.data;
          }
          _this.listLoading = false;
        });
      });
    },
    getOrgList: function getOrgList() {
      var _this2 = this;
      (0, _org.getOrgList)({
        commission_branches: 10
      }).then(function (response) {
        _this2.orgList = response.data;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleAdd: function handleAdd() {
      var _this3 = this;
      this.externalmanagement = Object.assign({}, defaultExternalManagement);
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this4 = this;
      this.externalmanagement = Object.assign({}, scope.row); // copy obj
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs['Form'].clearValidate();
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(form) {
        var _this5 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  _this5.disabled = true;
                  var isEdit = _this5.dialogType === 'edit';
                  if (isEdit) {
                    (0, _externalmanagement.updateExternalManagement)(_this5.externalmanagement.id, _this5.externalmanagement).then(function (res) {
                      setTimeout(function () {
                        _this5.disabled = false;
                      }, 1500);
                      _this5.getList();
                      _this5.dialogVisible = false;
                      _this5.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    (0, _externalmanagement.createExternalManagement)(_this5.externalmanagement).then(function (res) {
                      setTimeout(function () {
                        _this5.disabled = false;
                      }, 1500);
                      _this5.getList();
                      _this5.dialogVisible = false;
                      _this5.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                  setTimeout(function () {
                    _this5.disabled = false;
                  }, 1500);
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};